import { Row, Col } from 'react-bootstrap';
import { Card } from 'shared/components';
import { ButtonPlaceholder, InputPlaceholder } from 'shared/placeholders';

export const CostCentreFormSkeleton = ({ title }: { title: string }) => (
  <Row>
    <Col>
      <Card>
        <Card.Title>{title}</Card.Title>
        <Card.Body className="p-3">
          <div className="mb-2">
            <InputPlaceholder />
          </div>
          <div className="mb-2">
            <InputPlaceholder />
          </div>
          <InputPlaceholder />
        </Card.Body>
        <Card.Footer>
          <Row>
            <Col className="text-end">
              <ButtonPlaceholder>Guardar</ButtonPlaceholder>
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </Col>
  </Row>
);
